import { Avatar } from './Avatar';
import type { EnfantDuDossier } from './types';

/**
 * Choix de l'enfant affiché, quand le dossier en compte plusieurs.
 *
 * Il ne paraît qu'à partir de deux enfants : avec un seul, un sélecteur à une entrée est
 * un ornement qui coûte une ligne et n'apprend rien.
 *
 * **Pas d'entrée « Tous ».** Une fiche d'enfant se lit et se remplit enfant par enfant ;
 * les empiler n'aide personne, et l'option la plus large finissait par être celle qu'on
 * regardait par défaut — c'est-à-dire l'écran le moins lisible. Le premier enfant est
 * affiché à l'ouverture.
 *
 * Les prénoms sont écrits en toutes lettres, jamais réduits à une initiale ni à un
 * numéro. Un dossier de coparentalité parle d'enfants réels, et « E1 / E2 » les
 * transformerait en dossiers.
 *
 * L'ordre est celui du dossier — l'ordre de saisie, donc généralement l'ordre des
 * naissances. Le ré-ordonner par activité récente ferait bouger les boutons sous le doigt
 * d'une visite à l'autre.
 */
export function SelecteurEnfant({
  enfants,
  enfantActif,
  surChoix,
  maintenant,
}: {
  enfants: EnfantDuDossier[];
  enfantActif: string | null;
  surChoix: (childId: string) => void;
  maintenant: Date;
}) {
  if (enfants.length < 2) return null;

  return (
    <div className="selecteur-enfant" role="group" aria-label="Enfant affiché">
      {enfants.map((enfant) => (
        <button
          key={enfant.id}
          type="button"
          className={enfantActif === enfant.id ? 'actif' : undefined}
          aria-pressed={enfantActif === enfant.id}
          onClick={() => surChoix(enfant.id)}
        >
          <Avatar
            childId={enfant.id}
            avatar={enfant.avatar}
            prenom={enfant.firstName}
            naissance={enfant.birthDate}
            taille={28}
            maintenant={maintenant}
          />
          {enfant.firstName}
        </button>
      ))}
    </div>
  );
}
